import { MediaImage } from "../media/mediaImage";
import Swiper from "swiper";

export class Slider {
    defaultOptions = {
        containerClass: 'slider',
        wrapperClass: 'slider__wrapper',
        slideClass: 'slider__slide',
        slideActiveClass: 'slider__slide--active',
        navigation: {
            prevEl: '.slider__button--prev',
            nextEl: '.slider__button--next'
        },
        disabledClass: 'slider__button--disabled',
        hiddenClass: 'slider__button--hidden',
        initialSlide: 0,
        a11y: false,
        on: {
            transitionEnd: () => {
                this.loadImages();
            },
            update: () => {
                this.loadImages();
            }
        },
        touchEventsTarget: 'wrapper'
    };

    // staff
    root;
    wrapper;
    slides;
    navigation;
    prevEl;
    nextEl;
    pagination;
    paginationEl;

    constructor(slider, options) {
        // Si slider ya es un objeto jQuery, no se envuelve de nuevo
        this.slider = slider instanceof jQuery ? slider : $(slider);
        this.options = options;

        return this.init();
    }

    init() {
        if (!this.slider.length) {
            return;
        }

        // get scrollable(s)
        const scrollable = this.build();

        // init setup swiper
        const swiper = new Swiper(
            scrollable,
            $.extend({}, this.defaultOptions, this.options || {}, {
                // reset swiper config
                containerClass: this.defaultOptions.containerClass,
                wrapperClass: this.defaultOptions.wrapperClass,
                slideClass: this.defaultOptions.slideClass
            })
        );

        this.slider.addClass('slider--active');

        // Events
        $(window).ready(() => {
            if (swiper instanceof Array) {
                swiper.forEach((el) => {
                    el.update()
                });
            } else {
                swiper.update();
            }
        });

        return swiper;
    }

    build() {
        let scrollable = $();

        this.paginationEl = this.options.pagination && this.options.pagination.el || '';
        this.prevEl = (this.options.navigation && this.options.navigation.prevEl) || this.defaultOptions.navigation.prevEl;
        this.nextEl = (this.options.navigation && this.options.navigation.nextEl) || this.defaultOptions.navigation.nextEl;

        this.slider.each((index, el) => {
            this.root = $(el).addClass(this.defaultOptions.containerClass);

            // get or create slides
            this.slides = this.root.find('.' + this.defaultOptions.slideClass).length ||
                this.root
                    .find('.' + this.options.slideClass)
                    .wrap('<div class="' + this.defaultOptions.slideClass + '"/>')
                    .parent('.' + this.defaultOptions.slideClass);

            // get or create wrapper
            this.wrapper = this.root.find('.' + this.defaultOptions.wrapperClass).length ||
                this.root.find('.' + this.options.wrapperClass).addClass(this.defaultOptions.wrapperClass).length ||
                this.slides
                    .wrapAll('<div class="' + this.defaultOptions.wrapperClass + '"/>')
                    .closest('.' + this.defaultOptions.wrapperClass);

            scrollable = scrollable.add(this.root.filter('.' + this.defaultOptions.containerClass));

            // get or create navigation
            this.navigation = this.root.find([this.prevEl, this.nextEl].toString()).length || this.slides.length > 1 &&
                $('<a class="' + this.prevEl.replace('.', '') + '" /><a class="' + this.nextEl.replace('.', '') + '" />')
                    .appendTo(scrollable.eq(index));

            // remove pagination
            if (this.slides.length === 1) {
                this.root.find(this.paginationEl).remove();
            }
        });

        // release
        this.root = this.wrapper = this.slides = this.navigation = this.prevEl = this.nextEl = this.pagination = this.paginationEl = null;

        return scrollable;
    }

    getOptions() {
        return this.defaultOptions || {};
    }

    // auxiliary
    loadImages() {
        new MediaImage();
    }
}
